<template>
    <div>
        <Etapa
            :projeto="projeto"
            :etapa="etapa"
            :despesas="despesas"
            :servicos="obterServicos()"
            :permiteAtualizarCentroCusto="false"
            :permiteExcluirComprometimento="false"
            :permiteAcessoErroComprometimento="false"
            @recarregarDespesas="obterDespesas()"
        >
            <template slot="etapaFooter">
                <app-btn-voltar></app-btn-voltar>
            </template>
            <template slot="despesaAcoes">
            </template>
        </Etapa>
        <router-view></router-view>
    </div>
</template>

<script>
import Etapa from '../../componentes/etapas/Etapa'
import EtapasServicos from './EtapasServicos'

export default {
    components: {
        Etapa
    },

    data() {
        return {
            projeto: null,
            projeto2: null,
            etapa: null,
            despesas: null
        }
    },

    methods: {
        obterServicos() {
            return EtapasServicos
        },

        obterDespesas() {
            this.$store.dispatch('addRequest')
            EtapasServicos.obterDespesas(this.$route.params.etapaId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.despesas = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter despesas!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterProjetoEEtapa() {
            this.$store.dispatch('addRequest')
            EtapasServicos.obterProjeto(this.$route.params.projetoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.projeto = response.data
                            if (this.projeto.etapas.length > 0) {
                                this.etapa = this.projeto.etapas.filter(e => {return e.etapaId == this.$route.params.etapaId})[0]
                            }
                        } else {
                            this.$toast.error(
                                'Erro ao obter despesas!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        preencher() {
            if (this.$route.params.projeto != null && this.$route.params.projeto != null) {
                this.projeto = this.$route.params.projeto
                this.etapa = this.$route.params.etapa
            }else{
                this.obterProjetoEEtapa()
            } 
        }
    },

    created() {
        this.preencher()
        this.obterDespesas()
    }

}
</script>
